<template>
  <div>
    <div class="flex items-center justify-between mb-2">
      <Label class="text-sm font-medium">Layer Properties</Label>
      <div class="flex items-center gap-2">
        <Switch
          :checked="locked"
          @update:checked="$emit('update:locked', $event)"
          id="layer-lock"
        />
        <Label for="layer-lock" class="text-xs text-muted-foreground cursor-pointer">
          {{ locked ? 'Locked' : 'Unlocked' }}
        </Label>
      </div>
    </div>
    <div>
      <Label class="text-xs text-muted-foreground">Name</Label>
      <Input
        :model-value="name"
        @update:model-value="$emit('update:name', String($event))"
        @blur="$emit('blur')"
        class="h-8 mt-1"
        :disabled="locked"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Switch } from '@/components/ui/switch'

interface Props {
  name: string
  locked: boolean
}

defineProps<Props>()

defineEmits<{
  'update:name': [value: string]
  'update:locked': [value: boolean]
  'blur': []
}>()
</script>
